import React from 'react';
import { space } from 'styled-system';
import { styled, SvgIcon } from '@teko/ui';
import { Ripple } from '../Ripple/Ripple.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getBackground = (props) => {
  var _a, _b, _c, _d, _e, _f;
  if (props.disabled)
    return (_a = props.theme) == null ? void 0 : _a.colors.gray400;
  if (props.outline)
    return (_b = props.theme) == null ? void 0 : _b.colors.white;
  switch (props.variant) {
    case "primary":
      return ((_c = props.theme) == null ? void 0 : _c.brand.linear) || ((_d = props.theme) == null ? void 0 : _d.brand.primary);
    case "secondary":
      return (_e = props.theme) == null ? void 0 : _e.brand.secondary;
    case "tertiary":
      return (_f = props.theme) == null ? void 0 : _f.brand.tertiary;
    case "link":
      return "transparent";
  }
};
const getColor = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  if (props.outline) {
    switch (props.variant) {
      case "primary":
        return (_a = props.theme) == null ? void 0 : _a.brand.primary;
      case "secondary":
        return (_b = props.theme) == null ? void 0 : _b.brand.secondary;
      case "tertiary":
        return (_c = props.theme) == null ? void 0 : _c.brand.tertiary;
      default:
        return (_d = props.theme) == null ? void 0 : _d.brand.primary;
    }
  }
  switch (props.variant) {
    case "primary":
      return (_e = props.theme) == null ? void 0 : _e.colors.white;
    case "secondary":
      return (_f = props.theme) == null ? void 0 : _f.colors.white;
    case "tertiary":
      return (_g = props.theme) == null ? void 0 : _g.brand.primary;
    case "link":
      return (_h = props.theme) == null ? void 0 : _h.brand.primary;
    default:
      return (_i = props.theme) == null ? void 0 : _i.colors.white;
  }
};
const getSize = (props) => {
  switch (props.size) {
    case "sm":
      return `
        height: 32px;
        line-height: 32px;
        font-size: 13px;
        padding: 0 8px;
      `;
    case "md":
      return `
        height: 40px;
        line-height: 40px;
        font-size: 15px;
        padding: 0 8px;
      `;
    case "lg":
      return `
        height: 48px;
        line-height: 48px;
        font-size: 15px;
        padding: 0 8px;
      `;
  }
};
const StyledButton = styled.button((props) => {
  return `
      position: relative;
      border-radius: 4px;
      overflow: hidden;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      opacity: ${props.loading ? 0.69 : 1};
      color: ${getColor(props)};
      background: ${getBackground(props)};
      border: ${props.outline ? `1px solid ${getColor(props)}` : "none"};
      &:focus {
        outline: none;
      }
      ${props.fullWidth ? `width: 100%;` : ""}
      ${props.disabled ? "pointer-events: none;" : ""}
      ${getSize(props)}
    `;
}, space);
const Spinner = styled.div(({ theme, outline }) => `
    background: none;
    min-width: 20px;
    margin-right: 8px;
    position: relative;
    @keyframes ldio-yuapljtmof {
      0% {
        transform: rotate(0deg);
      }
      50% {
        transform: rotate(180deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    .ldio-yuapljtmof  {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      animation: ldio-yuapljtmof 1s linear infinite;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      box-shadow: 0 2px 0 0 ${outline ? theme == null ? void 0 : theme.brand.loading : theme == null ? void 0 : theme.colors.white};
      box-sizing: content-box;
    }
`);
let time = 0;
const Button = (_a) => {
  var _b = _a, {
    children,
    disabled,
    fullWidth,
    loading,
    variant = "primary",
    size = "md",
    icon,
    iconPosition = "left",
    rippleColor = "rgba(255, 255, 255, 0.6)",
    onClick,
    outline
  } = _b, props = __objRest(_b, [
    "children",
    "disabled",
    "fullWidth",
    "loading",
    "variant",
    "size",
    "icon",
    "iconPosition",
    "rippleColor",
    "onClick",
    "outline"
  ]);
  const handleClick = (event) => {
    event.stopPropagation();
    const rippleDelay = 200;
    const currentTime = new Date().getTime();
    if (onClick)
      setTimeout(() => {
        if (currentTime - time > rippleDelay) {
          time = currentTime;
          onClick(event);
        }
      }, rippleDelay);
  };
  return /* @__PURE__ */ React.createElement(StyledButton, __spreadValues({
    onClick: loading ? void 0 : handleClick,
    disabled,
    fullWidth,
    variant,
    size,
    outline
  }, props), loading ? /* @__PURE__ */ React.createElement(Spinner, {
    outline: !!outline
  }, /* @__PURE__ */ React.createElement("div", {
    className: "ldio-yuapljtmof"
  })) : icon && iconPosition === "left" && /* @__PURE__ */ React.createElement(SvgIcon, __spreadValues({
    marginRight: 2
  }, icon)), children, icon && iconPosition === "right" && /* @__PURE__ */ React.createElement(SvgIcon, __spreadValues({
    marginLeft: 2
  }, icon)), /* @__PURE__ */ React.createElement(Ripple, {
    color: rippleColor
  }));
};

export { Button };
